
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.33398 6.00033C1.33398 4.15938 2.82637 2.66699 4.66732 2.66699H11.334C13.1749 2.66699 14.6673 4.15938 14.6673 6.00033V9.0438C14.6673 10.8848 13.1749 12.3771 11.334 12.3771H11.1673V13.3452C11.1673 14.4397 9.92158 15.068 9.04146 14.4175L6.28102 12.3771H4.66732C2.82637 12.3771 1.33398 10.8848 1.33398 9.0438V6.00033ZM4.66732 4.00033C3.56275 4.00033 2.66732 4.89576 2.66732 6.00033V9.0438C2.66732 10.1484 3.56275 11.0438 4.66732 11.0438H6.50065C6.6433 11.0438 6.78219 11.0896 6.89691 11.1744L9.83398 13.3452V11.7105C9.83398 11.3423 10.1325 11.0438 10.5007 11.0438H11.334C12.4386 11.0438 13.334 10.1484 13.334 9.0438V6.00033C13.334 4.89576 12.4386 4.00033 11.334 4.00033H4.66732Z","fill":"currentColor"}})])
          )
        }
      }
    